import { func_cookie } from "./func_cookie";
import { func_validation } from "./func_validation";
import { func_currency } from "./func_currency";
import { func_datetime } from "./func_datetime";
import { func_intl } from "./func_intl";



export const func_cookieSetting = {
	
	// Token

	getCookieAlphyToken,
	getCookieAlphyNexToken,
	getCookieAlphyPayToken,

    // Outlet

    getCookieOutlet,
    removeCookieOutlet,

	// User

	getCookieUser,
	removeCookieUser,

	getCookieUserType,
	getCookieUserIsDistributor,
	
	// Local Settings

	getCookieNameLocalSettings,
	getCookieLocalSettings,
	appendCookieLocalSettings,

	// Local Settings (is User)

	getCookiePropNameIsUser,
	getCookieLocalSettingsIsUser,
	appendCookieLocalSettingsIsUser,

	// Local Settings (Search View Mode)
	
	getCookiePropNameSearchViewMode,
	getCookieLocalSettingsSearchViewMode,
	appendCookieLocalSettingsSearchViewMode,

	// Locale

	getCookieAlphyLocale,
	getCookieAlphyNexLocale,
	getCookieAlphyPayLocale,

	setCookieAlphyLocale,
	setCookieAlphyNexLocale,
	setCookieAlphyPayLocale,

	getAlphyDefaultLocale,
	getAlphyNexDefaultLocale,
	getAlphyPayDefaultLocale,

	getAlphyLocaleArray,
	getAlphyNexLocaleArray,
	getAlphyPayLocaleArray,

	getAlphyLocaleList, 
	getAlphyNexLocaleList, 
	getAlphyPayLocaleList,

	isAlphyLocaleValid,
	isAlphyNexLocaleValid,
	isAlphyPayLocaleValid,

	getValidAlphyLocale,
	getValidAlphyNexLocale,
	getValidAlphyPayLocale,

	// DateTime

    getCookieDateTimeFormat,
    getCookiePropDateFormat,
    getCookiePropShortTimeFormat,

    getDateFormat,
    getShortTimeFormat,

    retrieveUserDate,
    retrieveUserTime,
	retrieveUserDateTime,
	
	// Currency

	getCurrencyFormat,
	getCartCurrencyFormat,

	getCurrencySymbol,
	setCurrencySymbol,

	getCartCurrencySymbol,
	setCartCurrencySymbol,

	getCurrencyThousandSeparator,
	
    getCurrencyDecimalSeparator,
	
	getCurrencyDecimalScale,
	
	getFormattedPrice,
	getIntlFormattedPrice,

	// Site Setting
	
	getSiteSetting,
	getSiteSettingUrlStore,
	getSiteSettingUrlDashboard,
	getSiteSettingManifest,
	getSiteSettingFavIcon,
	getSiteSettingSocialMediaPreviewImage,
	getSiteSettingNavigationBarAccountLinkDisplayName,
	getSiteSettingCompanyDisplayName,
	getSiteSettingCompanyLogo,
	getSiteSettingDescription,

	getSiteSettingColorPrimary,
	getSiteSettingColorSecondary,
	getSiteSettingColorAccent,
	getSiteSettingColorSuccess,
	getSiteSettingColorPending,
	getSiteSettingColorError,

	getSiteSettingDefaultLanguage,
	getSiteSettingLanguageSelectionRequired,

	getSiteSettingCurrencySelectionRequired,
	getSiteSettingPublicStore,

	getSiteSettingPublicRegistration,
	getSiteSettingRegistrationManageUser,
	getSiteSettingPublicRegistrationManageUser,

	getSiteSettingOutletIntegration,
	getSiteSettingStockIntegration,
	getSiteSettingExpiryDateIntegration,
	
	getSiteSettingLiveChatIntegration,
	getSiteSettingPureChatIntegration,
	getSiteSettingLiveChatToken,

	getSiteSettingXilnexPurchaseOrderRequired,
	getSiteSettingXilnexSalesOrderRequired,
	getSiteSettingOrderRemarkRequired,
	getSiteSettingOrderDownloadInvoiceRequired,

	getSiteSettingCheckoutWithoutPaymentRequired,
	getSiteSettingManageUserCompanyDocumentRequired,
	getSiteSettingQuantityByMultiplesRequired,
	getSiteSettingBulkItemsCartOrdering,
	getSiteSettingPageBannerIntegration,
	getSiteSettingSettlementModuleIntegrationRequired,
	getSiteSettingManageShippingModuleIntegrationRequired,

};

function getCookieAlphyToken() {
	let retVal = func_cookie.getCookieValue("AlphyMartToken");
    return (retVal)?retVal:undefined;
}

function getCookieAlphyNexToken() {
	let retVal = func_cookie.getCookieValue("AlphyNexToken");
    return (retVal)?retVal:undefined;
}

function getCookieAlphyPayToken() {
	let retVal = func_cookie.getCookieValue("AlphyPayToken");
    return (retVal)?retVal:undefined;
}

function getCookieOutlet() {
    let retVal = func_cookie.getCookieValue("currentOutlet");
    return (retVal) ? retVal : "";
}

function removeCookieOutlet() {
    func_cookie.removeCookie("currentOutlet", { path: "/" });
}

function getCookieUser() {
	let retVal = func_cookie.getCookieValueParseObj("user");
    return (retVal)?retVal:{};
}

function removeCookieUser() {
	func_cookie.removeCookie("user");
}

function getCookieUserType(defaultVal) {
    return func_validation.getObjectPropertyValue(getCookieUser(), "type", defaultVal);
}

function getCookieUserIsDistributor(defaultVal) {
	let defaultVal_formatted = (defaultVal)? defaultVal: false;
    return func_validation.getObjectPropertyValue(getCookieUser(), "isDistributor", defaultVal_formatted);
}

function getCookieNameLocalSettings() {
	return "AlphySettings";
}

function getCookieLocalSettings() {
	let retVal = func_cookie.getCookieValueParseObj(getCookieNameLocalSettings());
	return (retVal) ? retVal : {};
}

function appendCookieLocalSettings(value, options) {
	return func_cookie.setCookieStringify_append(getCookieNameLocalSettings(), value, options);
}

function getCookiePropNameIsUser() {
	return "isUser";
}

function getCookieLocalSettingsIsUser(defaultVal) {
	return func_validation.getObjectPropertyValue(getCookieLocalSettings(), getCookiePropNameIsUser(), defaultVal);
}

// Set local setting to indicate whether user has logged in before
function appendCookieLocalSettingsIsUser(value) {
	if (func_validation.isNotNullUndefined(value)) {
		return func_cookie.setCookieStringify_append(getCookieNameLocalSettings(), { [getCookiePropNameIsUser()]: value });
	} else return false;
}

function getCookiePropNameSearchViewMode() {
	return "searchViewMode";
}

function getCookieLocalSettingsSearchViewMode(defaultVal) {
	return func_validation.getObjectPropertyValue(getCookieLocalSettings(), getCookiePropNameSearchViewMode(), defaultVal);
}

function appendCookieLocalSettingsSearchViewMode(value) {
	if (func_validation.isNotNullUndefined(value)) {
		return func_cookie.setCookieStringify_append(getCookieNameLocalSettings(), { [getCookiePropNameSearchViewMode()]: value });
	} else return false;
}

function getCookieAlphyLocale() {
	let retVal = func_cookie.getCookieValue("alphyLocale");
    return (retVal)?retVal:undefined;
}

function getCookieAlphyNexLocale() {
	let retVal = func_cookie.getCookieValue("alphyLocale");
    return (retVal)?retVal:undefined;
}

function getCookieAlphyPayLocale() {
	let retVal = func_cookie.getCookieValue("alphyLocale");
    return (retVal)?retVal:undefined;
}

function setCookieAlphyLocale(locale_new) {
	func_cookie.setCookie("alphyLocale", locale_new);
}

function setCookieAlphyNexLocale(locale_new) {
	func_cookie.setCookie("alphyLocale", locale_new);
}

function setCookieAlphyPayLocale(locale_new) {
	func_cookie.setCookie("alphyLocale", locale_new);
}

function getAlphyDefaultLocale() {
	return "en";
}

function getAlphyNexDefaultLocale() {
	return "en";
}

function getAlphyPayDefaultLocale() {
	return "en";
}

function getAlphyLocaleArray() {
	return [
		"en",
		"zh",
		"ms",
		"km",
	];
}

function getAlphyNexLocaleArray() {
	return [
		"en",
		"zh",
		"ms",
		"km",
	];
}

function getAlphyPayLocaleArray() {
	return [
		"en",
		"zh",
		"ms",
		"km",
	];
}

function getAlphyLocaleList() {
	return [
		{ locale: "en", language: "English" },
		{ locale: "zh", language: "中文" },
		{ locale: "ms", language: "Bahasa Melayu" },
		{ locale: "km", language: "ភាសាខ្មែរ" },
	];
}

function getAlphyNexLocaleList() {
	return [
		{ locale: "en", language: "English" },
		{ locale: "km", language: "ភាសាខ្មែរ" },
	];
}

function getAlphyPayLocaleList() {
	return [
		{ locale: "en", language: "English" },
		{ locale: "zh", language: "中文" },
	];
}

function isAlphyLocaleValid(locale) {
	return func_validation.isElementInArray(getAlphyLocaleArray(), locale);
}

function isAlphyNexLocaleValid(locale) {
	return func_validation.isElementInArray(getAlphyNexLocaleArray(), locale);
}

function isAlphyPayLocaleValid(locale) {
	return func_validation.isElementInArray(getAlphyPayLocaleArray(), locale);
}

function getValidAlphyLocale(locale) {
	if (isAlphyLocaleValid(locale)) return locale;
	return getAlphyDefaultLocale();
}

function getValidAlphyNexLocale(locale) {
	if (isAlphyNexLocaleValid(locale)) return locale;
	return getAlphyNexDefaultLocale();
}

function getValidAlphyPayLocale(locale) {
	if (isAlphyPayLocaleValid(locale)) return locale;
	return getAlphyPayDefaultLocale();
}

function getCookieDateTimeFormat() {
	let retVal = func_cookie.getCookieValueParseObj("dateTimeFormat");
    return (retVal)?retVal:{};
}

function getCookiePropDateFormat() {
    return "DateFormat";
}

function getCookiePropShortTimeFormat() {
    return "ShortTimeFormat";
}

function getDateFormat(defaultDateFormat) {
    let defaultDateFormat_formatted = (func_validation.isStringTrimNotEmpty(defaultDateFormat))?defaultDateFormat:"DD-MMM-YYYY";

    return func_validation.getObjectPropertyValue(getCookieDateTimeFormat(), getCookiePropDateFormat(), defaultDateFormat_formatted);
}

function getShortTimeFormat(defaultTimeFormat) {
    let defaultTimeFormat_formatted = (func_validation.isStringTrimNotEmpty(defaultTimeFormat))?defaultTimeFormat:"hh:mm A";

    return func_validation.getObjectPropertyValue(getCookieDateTimeFormat(), getCookiePropShortTimeFormat(), defaultTimeFormat_formatted);
}

function retrieveUserDate(datetime_raw) {
    return func_datetime.convertDateTimeToLocal(datetime_raw, getDateFormat());
}

function retrieveUserTime(datetime_raw) {
    return func_datetime.convertDateTimeToLocal(datetime_raw, getShortTimeFormat());
}

function retrieveUserDateTime(datetime_raw, separator, isDateTimeDisplayInverse) {
    let separator_formatted = func_validation.isStringTrimNotEmpty(separator)?separator:" ";
    let inverse_formatted = func_validation.isNotNullUndefined(isDateTimeDisplayInverse)?isDateTimeDisplayInverse:false;
    
    if (inverse_formatted) return retrieveUserTime(datetime_raw) + separator_formatted + retrieveUserDate(datetime_raw);
    return retrieveUserDate(datetime_raw) + separator_formatted + retrieveUserTime(datetime_raw);
}

function getCurrencyFormat() {
	let retVal = func_cookie.getCookieValueParseObj("currencyFormat");
    return (retVal)?retVal:{};
}

function getCartCurrencyFormat() {
	let retVal = func_cookie.getCookieValueParseObj("cartCurrencyFormat");
    return (retVal)?retVal:{};
}

function getCurrencySymbol(defaultVal) {
	let defaultVal_formatted = (func_validation.isNotNullUndefined(defaultVal))?defaultVal:"RM";
	return func_validation.getObjectPropertyValue(getCurrencyFormat(), "currencySymbol", defaultVal_formatted);
}

function setCurrencySymbol(currency_new) {
	func_cookie.setCookieStringify_append("currencyFormat", { currencySymbol: currency_new });
}

function getCartCurrencySymbol(defaultVal) {
	let defaultVal_formatted = (func_validation.isNotNullUndefined(defaultVal))?defaultVal:"RM";
	return func_validation.getObjectPropertyValue(getCartCurrencyFormat(), "cartCurrencySymbol", defaultVal_formatted);
}

function setCartCurrencySymbol(currency_new) {
	func_cookie.setCookieStringify_append("cartCurrencyFormat", { currencySymbol: currency_new });
}

function getCurrencyThousandSeparator(defaultVal) {
	let defaultVal_formatted = (func_validation.isNotNullUndefined(defaultVal))?defaultVal:",";
	return func_validation.getObjectPropertyValue(getCurrencyFormat(), "thousandSeparator", defaultVal_formatted);
}

function getCurrencyDecimalSeparator(defaultVal) {
	let defaultVal_formatted = (func_validation.isNotNullUndefined(defaultVal))?defaultVal:".";
	return func_validation.getObjectPropertyValue(getCurrencyFormat(), "decimalSeparator", defaultVal_formatted);
}

function getCurrencyDecimalScale(defaultVal) {
	let defaultVal_formatted = (func_validation.isNotNullUndefined(defaultVal))?defaultVal:2;
	return func_validation.getObjectPropertyValue(getCurrencyFormat(), "decimalScale", defaultVal_formatted);
}

function getFormattedPrice(price, options) {
    let price_formatted = "";
    if (func_validation.isNumberOrStringValid(price)) {
        price_formatted = parseFloat(price);
        
        let options_toNearestFiveCentEnabled = func_validation.getObjectPropertyValue(options, "toNearestFiveCentEnabled");
        if (options_toNearestFiveCentEnabled) price_formatted = func_currency.price_toNearestFiveCent(price_formatted);

        // Options - Precision
        price_formatted = parseFloat(price_formatted).toFixed(getCurrencyDecimalScale());

        // Options - Add Comma
        let options_commafyDisabled = func_validation.getObjectPropertyValue(options, "commafyDisabled");
        if (!options_commafyDisabled) price_formatted = func_currency.commafy(price_formatted, 3, getCurrencyThousandSeparator(), getCurrencyDecimalSeparator());
        
        // Options - Currency
        let options_currencyDisabled = func_validation.getObjectPropertyValue(options, "currencyDisabled");
        if (!options_currencyDisabled) price_formatted = getCurrencySymbol()+" "+price_formatted;

        // Options - Leading Text
        let options_prefix = func_validation.getObjectPropertyValue(options, "prefix");
        if (options_prefix) price_formatted = options_prefix+price_formatted;

        // Options - Trailing Text
        let options_suffix = func_validation.getObjectPropertyValue(options, "suffix");
        if (options_suffix) price_formatted = options_suffix+price_formatted;
        
    }
    
    return price_formatted;
}

function getIntlFormattedPrice(props, val, customOpts, formatNumberOpts) {
	// Not set by locale, nor formatNumber currency being used
	// Thus, need to set currency symbol and decimal scale based on value from API manually
	let currencySymbol = getCurrencySymbol()+" ";
	let precision = getCurrencyDecimalScale();

	let formatNumberOpts_formatted = { minimumFractionDigits: precision };
	if (func_validation.isObjectNotEmpty(formatNumberOpts)) {
		formatNumberOpts_formatted = { ...formatNumberOpts_formatted, ...formatNumberOpts };
	}
	
	if (func_validation.isObjectNotEmpty(customOpts)) {
		return func_intl.formatNumberCustom(props, val, { currencySymbol, ...customOpts }, formatNumberOpts_formatted);
	} else return func_intl.formatNumberCustom(props, val, { currencySymbol }, formatNumberOpts_formatted);
}

function getSiteSetting(props, siteSettingName, defaultValue) {
	let siteProfile = func_validation.getObjectPropertyValue(props, "siteProfile", {});
	let companySiteProfile = func_validation.getObjectPropertyValue(siteProfile, "companySiteProfile", {});
	return func_validation.getObjectPropertyValue(companySiteProfile, siteSettingName, defaultValue);
}

function getSiteSettingUrlStore(props, defaultVal) {
	let def = (defaultVal)?defaultVal:"";
	return getSiteSetting(props, "storeUrl", def);
}

function getSiteSettingUrlDashboard(props, defaultVal) {
	let def = (defaultVal)?defaultVal:"";
	return getSiteSetting(props, "dashboardUrl", def);
}

function getSiteSettingManifest(props, defaultVal) {
	let def = (defaultVal)?defaultVal:"";
	return getSiteSetting(props, "manifest", def);
}

function getSiteSettingFavIcon(props, defaultVal) {
	let def = (defaultVal)?defaultVal:"";
	return getSiteSetting(props, "favIconUrl", def);
}

function getSiteSettingSocialMediaPreviewImage(props, defaultVal) {
	let def = (defaultVal)?defaultVal:"";
	return getSiteSetting(props, "linkPreviewImage", def);
}

function getSiteSettingNavigationBarAccountLinkDisplayName(props, defaultVal) {
	let def = (defaultVal)?defaultVal:"";
	return getSiteSetting(props, "isShowingDisplayName", def);
}

function getSiteSettingCompanyDisplayName(props, defaultVal) {
	let def = (defaultVal)?defaultVal:"";
	return getSiteSetting(props, "companyDisplayName", def);
}

function getSiteSettingCompanyLogo(props, defaultVal) {
	let def = (defaultVal)?defaultVal:"";
	return getSiteSetting(props, "companyLogoUrl", def);
}

function getSiteSettingDescription(props, defaultVal) {
	let def = (defaultVal)?defaultVal:"";
	return getSiteSetting(props, "description", def);
}

function getSiteSettingColorPrimary(props, defaultVal) {
	let def = (defaultVal)?defaultVal:"";
	return getSiteSetting(props, "primaryColour", def);
}

function getSiteSettingColorSecondary(props, defaultVal) {
	let def = (defaultVal)?defaultVal:"";
	return getSiteSetting(props, "secondaryColour", def);
}

function getSiteSettingColorAccent(props, defaultVal) {
	let def = (defaultVal)?defaultVal:"";
	return getSiteSetting(props, "accentColour", def);
}

function getSiteSettingColorSuccess(props, defaultVal) {
	let def = (defaultVal)?defaultVal:"";
	return getSiteSetting(props, "successColour", def);
}

function getSiteSettingColorPending(props, defaultVal) {
	let def = (defaultVal)?defaultVal:"";
	return getSiteSetting(props, "pendingColour", def);
}

function getSiteSettingColorError(props, defaultVal) {
	let def = (defaultVal)?defaultVal:"";
	return getSiteSetting(props, "errorColour", def);
}

function getSiteSettingDefaultLanguage(props, defaultVal) {
	let def = (defaultVal)?defaultVal:"";
	return getSiteSetting(props, "defaultLanguage", def);
}

function getSiteSettingLanguageSelectionRequired(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isMultiLanguageSupported", def);
}

function getSiteSettingCurrencySelectionRequired(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isMultiCurrencySupported", def);
}

function getSiteSettingPublicStore(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isPublicStore", def);
}

function getSiteSettingPublicRegistration(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isAllowPublicRegistration", def);
}

function getSiteSettingRegistrationManageUser(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isShowingCompactRegistrationForm", def);
}

function getSiteSettingPublicRegistrationManageUser(props, defaultVal) {
	return (getSiteSettingPublicRegistration(props, defaultVal) &&
			getSiteSettingRegistrationManageUser(props, defaultVal));
}

function getSiteSettingOutletIntegration(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isUsingXilnexOutlet", def);
}

function getSiteSettingStockIntegration(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "integrateStockFromXilnex", def);
}

function getSiteSettingExpiryDateIntegration(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isShowingExpiryDate", def);
}

function getSiteSettingLiveChatIntegration(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isSupportLiveChat", def);
}

function getSiteSettingPureChatIntegration(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isSupportPureChat", def);
}

function getSiteSettingLiveChatToken(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "liveChatToken", def);
}

function getSiteSettingXilnexPurchaseOrderRequired(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isUsingXilnexPurchaseOrder", def);
}

function getSiteSettingXilnexSalesOrderRequired(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isUsingXilnexSalesOrder", def);
}

function getSiteSettingOrderRemarkRequired(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isOrderRemarkRequired", def);
}

function getSiteSettingOrderDownloadInvoiceRequired(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isAbleToDownloadInvoice", def);
}

function getSiteSettingCheckoutWithoutPaymentRequired(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isCheckOutWithoutPayment", def);
}

function getSiteSettingManageUserCompanyDocumentRequired(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isCompanyDocumentRequired", def);
}

function getSiteSettingQuantityByMultiplesRequired(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isShowingPackQuantityReminder", def);
}

function getSiteSettingBulkItemsCartOrdering(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isSupportCompactView", def);
}

function getSiteSettingPageBannerIntegration(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isShowingBanner", def);
}

function getSiteSettingSettlementModuleIntegrationRequired(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isShowingSettlementModule", def);
}

function getSiteSettingManageShippingModuleIntegrationRequired(props, defaultVal) {
	let def = (defaultVal)?defaultVal:false;
	return getSiteSetting(props, "isShowingManageShippingFeeModule", def);
}
